import type { Pin } from '@/model';
import { decodeAccount, decodeMe } from './decode';
import { replacePins, type AccountStore } from './store';

/** Unversioned REST objects can replace stream state only if no update overtook the request. */
export async function applyMutableReceipt(db: AccountStore, response: Record<string, unknown>, fresh: boolean, pinsRevision?: number): Promise<void> {
  const accounts = Array.isArray(response.accounts) ? response.accounts.map(decodeAccount) : [];
  if (response.account) accounts.push(decodeAccount(response.account));
  for (const account of accounts) {
    const mine = await db.me.get('me');
    if (fresh) {
      await db.accounts.put(account);
      if (mine?.value.account.id === account.id) await db.me.put({ id: 'me', value: { ...mine.value, account } });
    } else await db.resourceFetches.put({ id: mine?.value.account.id === account.id ? 'me' : `account:${account.id}` });
  }
  if (response.me && typeof response.me === 'object' && 'account' in response.me) {
    if (fresh) { const me = decodeMe(response.me); await db.me.put({ id: 'me', value: me }); await db.accounts.put(me.account); }
    else await db.resourceFetches.put({ id: 'me' });
  }
  if (Array.isArray(response.pins)) {
    if (fresh && (pinsRevision === undefined || ((await db.meta.get('sync'))?.pins_revision ?? 0) === pinsRevision)) await replacePins(db, response.pins as Pin[]);
    else await db.resourceFetches.put({ id: 'pins' });
  }
}
